import { render } from "./HeroiconsOutlineCloudDownload.vue?vue&type=template&id=49bc5722"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCloudDownload.vue"]])

export default __exports__